import { Navigate, Route, Routes } from 'react-router-dom';
import { PageTitle } from '../../../_start/layout/core';
import { CookieBannersPage } from './pages/cookie-banner/CookieBannersPage';
import { UpdateCookieBanner } from './pages/cookie-banner/UpdateCookieBanner';
import { FootersPage } from './pages/footer/FootersPage';
import { UpdateFooter } from './pages/footer/UpdateFooter';
import { MenusPage } from './pages/MenusPage';
import { UpdateMenu } from './pages/UpdateMenu';

export const LayoutManagementPage = () => {
  return (
    <Routes>
      {/* begin::Page Routes */}
      <Route
        path="menus"
        element={
          <>
            <PageTitle>Menus</PageTitle>
            <MenusPage />
          </>
        }
      />

      <Route
        path="menus/:id/update"
        element={
          <>
            <PageTitle>Menus</PageTitle>
            <UpdateMenu />
          </>
        }
      />

      <Route
        path="footers"
        element={
          <>
            <PageTitle>Footers</PageTitle>
            <FootersPage />
          </>
        }
      />

      <Route
        path="footers/:id/update"
        element={
          <>
            <PageTitle>Footers</PageTitle>
            <UpdateFooter />
          </>
        }
      />

      <Route
        path="cookie-banner"
        element={
          <>
            <PageTitle>Cookie Banner</PageTitle>
            <CookieBannersPage />
          </>
        }
      />

      <Route
        path="cookie-banner/:id/update"
        element={
          <>
            <PageTitle>Cookie Banner</PageTitle>
            <UpdateCookieBanner />
          </>
        }
      />

      {/* end::Page Routes */}

      <Route
        index
        element={<Navigate to="/layout-management/menus" replace />}
      />

      <Route
        path="*"
        element={<Navigate to="/layout-management/menus" replace />}
      />
    </Routes>
  );
};
